import { getCookie } from '../../utils/cookies'

export default {
	namespaced: true,

	state: { $locale: getCookie('locale') },
    mutations: { updateLocale: function(state, newLang) { state.$locale = newLang; } }

}

